import clsx from "clsx";
import Modal from "../Modal/Modal";
import RadioGroup from "../RadioGroup/RadioGroup";
import CollapsibleBlock from "../CollapsibleBlock/CollapsibleBlock";
import { useTranslation } from "react-i18next";
import { MdClose, MdOutlineUnfoldMore, MdTableView } from "react-icons/md";
import useModalsStore from "src/store/modalsStore";
import useCollapsibles from "src/hooks/useCollapsibles";
import SettingsPerDeviceInfoBlock from "../InfoBlock/SettingsPerDeviceInfoBlock/SettingsPerDeviceInfoBlock";
import useUiPreferences, { EPaginationStyle } from "src/store/useUiPreferences";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

const PaginationSettingsModal: React.FC = () => {
  const { t } = useTranslation(["modals", "common"]);
  const tablesUiPreferences = useUiPreferences((s) => s.tables);
  const setUiPreferences = useUiPreferences((s) => s.setUiPreferences);
  const { collapsiblePreferences, updateCollapsible } = useCollapsibles();
  const { setShowPaginationSettingsModal, setShowTableSettingsModal } =
    useModalsStore();

  return (
    <Modal
      onEscape={() => setShowPaginationSettingsModal(false)}
      className={clsx(["!w-full", "md:!min-w-[400px]", "md:!max-w-[400px]"])}
    >
      <Modal.Header
        onClose={() => setShowPaginationSettingsModal(false)}
        title={t("Configuración de paginación")}
      />
      <Modal.Body>
        <div className={clsx(["flex", "flex-col", "gap-4", "w-full", "pb-2"])}>
          <SettingsPerDeviceInfoBlock />
          <CollapsibleBlock
            title={t("modals:table_settings.collapsibles.style.title")}
            // open={collapsiblePreferences.tablePreferencesPaginationOpen}
            blocked
            open
            onChange={(isOpen: boolean) => {
              updateCollapsible({ tablePreferencesPaginationOpen: isOpen });
            }}
            icon={
              <MdOutlineUnfoldMore
                className={clsx(["rotate-90"])}
                size={ICON_SIZES.SM}
              />
            }
          >
            <RadioGroup
              onChange={(value: any) => {
                setUiPreferences({
                  tables: {
                    paginationStyle: value,
                  },
                });
              }}
              selected={tablesUiPreferences.paginationStyle}
              columns={1}
              options={[
                {
                  label: t("modals:table_settings.collapsibles.style.top"),
                  description: t(
                    "modals:table_settings.collapsibles.style.top_description",
                  ),
                  value: EPaginationStyle.TOP,
                },
                {
                  label: t("modals:table_settings.collapsibles.style.bottom"),
                  description: t(
                    "modals:table_settings.collapsibles.style.bottom_description",
                  ),
                  value: EPaginationStyle.BOTTOM,
                },
                {
                  label: t("modals:table_settings.collapsibles.style.double"),
                  description: t(
                    "modals:table_settings.collapsibles.style.double_description",
                  ),
                  value: EPaginationStyle.DOUBLE,
                },
              ]}
            />
          </CollapsibleBlock>
        </div>
      </Modal.Body>
      <Modal.Footer
        actions={[
          {
            text: t("common:buttons.close"),
            onClick: () => setShowPaginationSettingsModal(false),
            kind: EButtonKind.NORMAL,
            icon: <MdClose size={ICON_SIZES.SM} />,
          },
        ]}
        leftContent={
          <ButtonGroup
            buttons={[
              {
                icon: <MdTableView />,
                onClick: () => {
                  setShowPaginationSettingsModal(false);
                  setShowTableSettingsModal(true);
                },
                tooltip: "Tablas",
              },
            ]}
          />
        }
      />
    </Modal>
  );
};

export default PaginationSettingsModal;
